import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var ResetUndoIcon = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Reset Undo Icon" : _b, props = __rest(_a, ["ariaLabel"]);
    return (React.createElement(SvgIcon, __assign({}, props, { ariaLabel: ariaLabel }),
        React.createElement("path", { d: "M5.762 5.764a5.962 5.962 0 014.86-1.732c2.751.278 5.016 2.512 5.323 5.264a5.987 5.987 0 01-11.353 3.285.751.751 0 01.675-1.08c.278 0 .54.15.66.397a4.495 4.495 0 005.1 2.482 4.46 4.46 0 003.359-3.39 4.501 4.501 0 00-4.387-5.488 4.435 4.435 0 00-3.165 1.335l1.133 1.132c.472.472.142 1.282-.525 1.282H4.75a.752.752 0 01-.75-.75V5.81c0-.667.81-1.004 1.282-.532l.48.487z" })));
};

export { ResetUndoIcon };
//# sourceMappingURL=ResetUndoIcon.esm.js.map
